import script from "./FichaCourse.vue?vue&type=script&setup=true&lang=js"
export * from "./FichaCourse.vue?vue&type=script&setup=true&lang=js"

import "./FichaCourse.vue?vue&type=style&index=0&id=897b8884&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\unensedu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-897b8884"]])

export default __exports__